import React, { memo } from "react"
import { CONTENT_TYPES, PADDING, PAGES } from "@/constants"
import TablePreviewModule from "@/components/TablePreviewModule"
import { getItemType, getMapKey2 } from "@/utils/utils"
import { useRouter } from "next/router"
import SubPageBanner from "@/components/Banners/SubPage/SubPageBanner"
import TypographyBanner from "@/components/Banners/Typography"

import BannerKRS from "@/components/Banners/KRS"
import TabsAndImage from "@/components/tabsAndImage/TabsAndImage"
import DraggableLetters from "@/components/draggableLetters/DraggableLetters"
import NewsThumbnail from "@/components/newsThumbnail/NewsThumbnail"
import RulesTiles from "@/components/rulesTiles/RulesTiles"
import TextAndDescriptionWithButton from "@/components/TextAndDescriptionWithButton"
import DescriptionWithImage from "@/components/DescriptionWithImage"
import ContactForm from "@/components/Forms/ContactForm"
import Calendar from "@/components/Calendar"
import FAQ from "@/components/FAQ"
import StructuredTextModule from "@/components/StructuredTextModule/index"
import SocialMediaFeed from "@/components/SocialMediaFeed"
import Stats from "@/components/Stats"
import BannerCallToActionModule from "@/components/BannerCallToActionModule"
import BannerCallToActionPreviewModule from "@/components/BannerCallToActionModule/Preview"
import ImageWithCaption from "@/components/ImageWithCaption"
import TeamModule from "@/components/TeamModule"
import Payment from "@/components/payment/PaymentMain"
import ParallaxImageAndDescription from "@/components/ParallaxImageAndDescription"
import Partners from "@/components/Partners"
import TableModule from "@/components/TableModule"
import ExpandingListAndDescription from "@/components/ExpandingListAndDescription"
import HeaderDescriptionModule from "@/components/Header&DescriptionModule"
import ParallaxSlider from "@/components/ParallaxSlider"
import GalleryModule from "@/components/GalleryModule"
import HighlightedHeading from "@/components/HighlightedHeading"
import TilesModule from "@/components/TilesModule"
import CareerModule from "@/components/CareerModule"
import PinnedHistoryModule from "@/components/PinnedHistoryModule"
import VideoWithCoverModule from "@/components/VideoWithCoverModule"
import GalleryDescriptionTextModule from "@/components/GalleryDescriptionTextModule"
import ColorfulSquaresModule from "@/components/ColorfulSquares"
import Archive from "@/components/Archive"
import SignupFormModule from "@/components/Forms/SignupFormModule"
import PressMediaFeed from "@/components/Press"
import ExpandingTabs from "@/components/ExpandingTabs"
import DonorStories from "@/components/DonorStories"
import BranchNavigator from "@/components/BranchNavigator"
import HeadingGraphic from "@/components/HeadingGraphicModule"
import TwoImagesInRowModule from "@/components/TwoImagesInRowModule"
import StatesMapModule from "@/components/Maps"
import FactsModule from "@/components/FactsModule"
import ExpandableVideo from "@/components/expandingVideo/ExpandingVideo"
import ChosenNewsModule from "@/components/ChosenNewsModule"
import ArticlesList from "@/components/ArticlesList"
import CountDownTimer from "@/components/CountDownTimer"
import ShareModule from "@/components/Share"

function formatTypename(inputStr) {
	let newStr = inputStr.replace(/Record$/, "")
	newStr = newStr.replace(/([A-Z])/g, " $1").trim()

	return newStr
}

const ContentSwitcher = ({ type, item, globalBannerData, isPreviewPage }) => {
	switch (type) {
		// case CONTENT_TYPES.NEWS_THUMBNAIL:
		// 	return <NewsThumbnail key=getMapKey(item, index) data={item}  />;
		// case CONTENT_TYPES.RULES_TILES:
		// 	return <RulesTiles key=getMapKey(item, index) data={item}  />;
		case CONTENT_TYPES.GLOBAL_BASED_BANNER:
			return isPreviewPage ? <SubPageBanner data={item} /> : globalBannerData ? <SubPageBanner data={globalBannerData} /> : null
		case CONTENT_TYPES.TABS_AND_IMAGE:
			return <TabsAndImage data={item} />
		case CONTENT_TYPES.TEXT_AND_DESCRIPTION_WITH_BUTTON:
			return <TextAndDescriptionWithButton data={item} />
		case CONTENT_TYPES.DESCRIPTION_WITH_IMAGE:
			return <DescriptionWithImage data={item} />
		case CONTENT_TYPES.CONTACT_FORM_PREVIEW:
			return <ContactForm data={item} />
		case CONTENT_TYPES.HEADER_AND_DESCRIPTION_MODULE:
			return <HeaderDescriptionModule data={item} />
		case CONTENT_TYPES.CALENDAR:
			return <Calendar data={item} />
		case CONTENT_TYPES.FAQ_PREVIEW:
			return <FAQ data={item} />
		case CONTENT_TYPES.DRAGGABLE_LETTERS:
			return <DraggableLetters data={item} />
		case CONTENT_TYPES.RULES_TILES:
			return <RulesTiles data={item} />
		case CONTENT_TYPES.NEWS_THUMBNAIL:
			return <NewsThumbnail data={item} />
		case CONTENT_TYPES.STRUCTURED_TEXT_MODULE:
			return <StructuredTextModule data={item} />
		case CONTENT_TYPES.SOCIAL_MEDIA_FEED:
			return <SocialMediaFeed data={item} />
		case CONTENT_TYPES.STATS:
			return <Stats data={item} />
		case CONTENT_TYPES.BANNER_CALL_TO_ACTION_MODULE:
			return <BannerCallToActionModule data={item} />
		case CONTENT_TYPES.BANNER_CALL_TO_ACTION_MODULE_PREVIEW:
			return <BannerCallToActionPreviewModule data={item} />
		case CONTENT_TYPES.IMAGE_WITH_CAPTION:
			return <ImageWithCaption data={item} />
		case CONTENT_TYPES.PAYMENT_MODULE:
			return <Payment data={item} />
		case CONTENT_TYPES.TEAM_MODULE:
			return <TeamModule data={item} />
		case CONTENT_TYPES.PARTNERS:
			return <Partners data={item} />
		case CONTENT_TYPES.PARALLAX_IMAGE_AND_DESCRIPTION:
			return <ParallaxImageAndDescription data={item} />
		case CONTENT_TYPES.TABLE_MODULE:
			return <TableModule data={item} />
		case CONTENT_TYPES.TABLE_PREVIEW_MODULE:
			return <TablePreviewModule data={item} />
		case CONTENT_TYPES.EXPANDING_LIST_AND_DESCRIPTION:
			return <ExpandingListAndDescription data={item} />
		case CONTENT_TYPES.PARALLAX_SLIDER:
			return <ParallaxSlider data={item} />
		case CONTENT_TYPES.GALLERY_MODULE:
			return <GalleryModule data={item} />
		case CONTENT_TYPES.HIGHLIGHTED_HEADING:
			return <HighlightedHeading data={item} />
		case CONTENT_TYPES.TILES_MODULE:
			return <TilesModule data={item} />
		case CONTENT_TYPES.CAREER_MODULE:
			return <CareerModule data={item} />
		case CONTENT_TYPES.PINNED_HISTORY:
			return <PinnedHistoryModule data={item} />
		case CONTENT_TYPES.VIDEO_WITH_COVER_MODULE:
			return <VideoWithCoverModule data={item} />
		case CONTENT_TYPES.GALLERY_DESCRIPTION_TEXT_MODULE:
			return <GalleryDescriptionTextModule data={item} />
		case CONTENT_TYPES.COLORFUL_SQUARES_MODULE:
			return <ColorfulSquaresModule data={item} />
		case CONTENT_TYPES.SIGNUP_FORM_MODULE:
			return <SignupFormModule data={item} />
		case CONTENT_TYPES.ARCHIVE:
			return <Archive data={item} />
		case CONTENT_TYPES.PRESS_MEDIA_FEED:
			return <PressMediaFeed data={item} />
		case CONTENT_TYPES.TWO_IMAGES_IN_ROW_MODULE:
			return <TwoImagesInRowModule data={item} />
		case CONTENT_TYPES.EXPANDING_TABS_MODULE:
			return <ExpandingTabs data={item} />
		case CONTENT_TYPES.DONOR_STORIES:
			return <DonorStories data={item} />
		case CONTENT_TYPES.BRANCH_NAVIGATOR:
			return <BranchNavigator data={item} />
		case CONTENT_TYPES.HEADING_GRAPHIC_MODULE:
			return <HeadingGraphic data={item} />
		case CONTENT_TYPES.STATES_MAP:
			return <StatesMapModule data={item} />
		case CONTENT_TYPES.FACTS_MODULE:
			return <FactsModule data={item} />
		case CONTENT_TYPES.BANNER_TYPOGRAPHY:
			return <TypographyBanner data={item} />
		case CONTENT_TYPES.CHOSEN_NEWS_MODULE:
			return <ChosenNewsModule data={item} />
		case CONTENT_TYPES.EXPANDABLE_VIDEO:
			return <ExpandableVideo data={item} />
		case CONTENT_TYPES.ARTICLES_LIST_PREVIEW_MODULE:
			return <ArticlesList data={item} />
		case CONTENT_TYPES.KRS_BANNER:
			return <BannerKRS data={item} />
		case CONTENT_TYPES.GALLERY_PREVIEW_MODULE:
			return <GalleryModule data={item} isPreview={true} />
		case CONTENT_TYPES.HEADER_DESCRIPTION_PREVIEW_MODULE:
			return <HeaderDescriptionModule data={item} isPreview={true} />
		case CONTENT_TYPES.TILES_MODULE_PREVIEW:
			return <TilesModule data={item} isPreview={true} />
		case CONTENT_TYPES.COUNT_DOWN_TIMER_MODULE:
			return <CountDownTimer data={item} />
		case CONTENT_TYPES.SHARE_MODULE:
			return <ShareModule data={item} />
		default:
			return null
	}
}

const ContentItem = memo(function Item({ item, type, isPreviewPage, globalBannerData }) {
	const formattedItemType = formatTypename(type)

	return (
		<>
			{isPreviewPage && (
				<HeaderDescriptionModule
					data={{
						paddings: {
							top: PADDING.NONE,
							bottom: PADDING.NONE,
						},
						headerDescription: {
							header: formattedItemType,
						},
					}}
				/>
			)}
			<ContentSwitcher item={item} type={type} globalBannerData={globalBannerData} isPreviewPage={isPreviewPage} />
		</>
	)
})

const ExtendedContent = ({ content, globalBannerData = null }) => {
	const { asPath } = useRouter()
	const isPreviewPage = asPath.includes(PAGES.PREVIEW)
	if (!Array.isArray(content)) {
		return null
	}
	return (
		<>
			{content.map((item, index) => {
				const type = getItemType(item)
				return (
					<ContentItem
						key={getMapKey2(item, index)}
						item={item}
						type={type}
						isPreviewPage={isPreviewPage}
						globalBannerData={globalBannerData}
					/>
				)
			})}
		</>
	)
}

export default ExtendedContent